import { buildStyleFns, buildStylePropFn } from './buildStyleFns';
export const positionStyleFnConfigs = [
    {
        name: 'position',
        properties: ['position'],
        system: 'none',
    },
    {
        name: 'zIndex',
        properties: ['zIndex'],
        system: 'none',
    },
    {
        name: 'top',
        properties: ['top'],
        system: 'none',
    },
    {
        name: 'right',
        properties: ['right'],
        system: 'none',
    },
    {
        name: 'bottom',
        properties: ['bottom'],
        system: 'none',
    },
    {
        name: 'left',
        properties: ['left'],
        system: 'none',
    },
    {
        name: 'inset',
        properties: ['inset'],
        system: 'none',
    },
    {
        name: 'insetInlineStart',
        properties: ['insetInlineStart'],
        system: 'none',
    },
    {
        name: 'insetInlineEnd',
        properties: ['insetInlineEnd'],
        system: 'none',
    },
];
export const positionStyleFns = buildStyleFns(positionStyleFnConfigs);
/**
 * A style prop function that takes component props and returns position styles.
 * If no `PositionProps` are found, it returns an empty object.
 *
 * @example
 * ```
 * const BoxExample = () => (
 *   <Box position="absolute" top="50%">
 *     Hello, positions!
 *   </Box>
 * );
 * ```
 */
export const position = buildStylePropFn(positionStyleFns);
